import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFormControl from 'UIComponents/form/UIFormControl';
import CampaignSelect from 'campaigns-lib/components/CampaignSelect';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CampaignFilterFormControl({
  hasCampaignsReadAccess,
  value,
  onChange,
  'data-test-id': dataTestId
}) {
  if (!hasCampaignsReadAccess) {
    return null;
  }
  return /*#__PURE__*/_jsx(UIFormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaignSelect.formControlLabel"
    }),
    children: /*#__PURE__*/_jsx(CampaignSelect, {
      onChange: onChange,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.all"
      }),
      value: value,
      uiSelectProps: {
        'data-test-id': dataTestId
      }
    })
  });
}
CampaignFilterFormControl.propTypes = {
  hasCampaignsReadAccess: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired
};